import dayjs from 'dayjs';
import { useUpdateExpense } from 'api/expenses/use-update-expense.ts';
import type { TUpdateExpenseReq } from 'api/swagger';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard';
import { formatDate } from 'shared/utils/time/format-date';
import { EFormDrawerWithButtonIconType, FormDrawerWithButton } from 'components/common/form-drawer-with-button';
import { ExpenseForm } from 'components/expenses/expense-form';
import type { IExpenseFormFields } from 'components/expenses/expense-form';
import type { IExpenseEditProps } from './types';

export const ExpenseEditComponent = (props: IExpenseEditProps) => {
  const { expense } = props;

  const { mutateAsync: updateExpense, isLoading } = useUpdateExpense(expense.id);

  const initialValues: Partial<IExpenseFormFields> = {
    clientNumber: expense.clientNumber != null ? String(expense.clientNumber) : undefined,
    typeId: expense.typeId,
    price: expense.price,
    currency: expense.currency,
    endDate: expense.endDate ? dayjs(expense.endDate) : undefined,
    partner: expense.partner
      ? { value: expense.partner.id, label: expense.partner.shortName || expense.partner.name }
      : undefined,
    contact: expense.contact ? { value: expense.contact.id, label: expense.contact.name } : undefined,
  };

  const onFinish = async (values: IExpenseFormFields) => {
    const apiVariables: TUpdateExpenseReq = {
      clientNumber: values.clientNumber,
      typeId: values.typeId,
      price: values.price,
      currency: values.currency,
      endDate: formatDate(values.endDate),
      partnerId: values.partner ? values.partner.value : null,
      contactId: values.contact ? values.contact.value : null,
    };

    await updateExpense(apiVariables);
  };

  return (
    <FormDrawerWithButton
      formComponent={ExpenseForm}
      formProps={{ initialValues }}
      title='Edit expense'
      buttonLabel='Edit'
      isLoading={isLoading}
      iconType={EFormDrawerWithButtonIconType.EDIT}
      onFinish={onFinish}
    />
  );
};

export const ExpenseEdit = withRoleGuard<IExpenseEditProps>(ExpenseEditComponent, [
  UserRole.admin,
  UserRole.assistant,
  UserRole.accountant,
]);
